import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChair: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChair"><Path fillRule="evenodd" clipRule="evenodd" d="M5 2H19V11H17V13H20V15H19V22H17V19H7V22H5V15H4V13H7V11H5V2ZM15 11H9V13H15V11ZM7 15V17H17V15H7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChair;
